import React from 'react';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';
import styles from './consignment-form-footer.module.scss';

const ConsignmentFormFooter: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className={clsx(styles.consignmentForm__footer, 'vc-text-s')}>
      <p>{t('CONSIGNMENT.FORM.BOTTOM_INFO')}</p>
    </div>
  );
};

export default ConsignmentFormFooter;
